module.exports = __webpack_public_path__ + "img/max-file-content-signature-configure.0e284965.svg";